// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mention-list {
  background: var(--bg-secondary, #2a2a2a);
  border: 1px solid var(--border-color, #333);
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  padding: 0.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  max-height: 200px;
  overflow-y: auto;
  min-width: 150px;
}

.mention-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.5rem;
  border-radius: 0.3rem;
  border: none;
  background: transparent;
  color: var(--text-primary, #fff);
  cursor: pointer;
  text-align: left;
  transition: background 0.2s;
}

.mention-item:hover,
.mention-item.is-selected {
  background: var(--accent-primary, #007bff);
  color: #fff;
}

.mention-avatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
  background-color: var(--bg-primary, #121212);
}

.mention-name {
  font-size: 0.9rem;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/components/RichEditor/MentionList.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".mention-list {\n  background: var(--bg-secondary, #2a2a2a);\n  border: 1px solid var(--border-color, #333);\n  border-radius: 0.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  padding: 0.2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  max-height: 200px;\n  overflow-y: auto;\n  min-width: 150px;\n}\n\n.mention-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0.5rem;\n  border-radius: 0.3rem;\n  border: none;\n  background: transparent;\n  color: var(--text-primary, #fff);\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.2s;\n}\n\n.mention-item:hover,\n.mention-item.is-selected {\n  background: var(--accent-primary, #007bff);\n  color: #fff;\n}\n\n.mention-avatar {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  object-fit: cover;\n  background-color: var(--bg-primary, #121212);\n}\n\n.mention-name {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
